module.exports = __webpack_public_path__ + "media/file-icons/powerpoint-1469589d.gif";